import { makeAutoObservable } from 'mobx';
import {DomainStore} from 'shared/store';
import {t} from 'shared/core';
import {endpoints, types} from 'main/tools';
import {successAlert} from 'shared/tools';

class CycleDirectoryState {
  history;
  store = new DomainStore();

  selectedCycle;

  constructor() {
    makeAutoObservable(this, {
      history: false,
      store: false
    });
  }

  receiveProps({history}) {
    this.history = history;
  }

  setInteractiveAgent(agent) {
    this.interactiveAgent = agent;
  }

  async addNewCycle() {
    const {model} = await this.store.post(
      endpoints.PERFORMANCE_REVIEWS.CYCLES.DIRECTORY,
      types.PERFORMANCE_REVIEWS.CYCLE
    );

    this.history.push(`/reviews/${model.id}/edit`);
  }

  async removeCycle(cycle) {
    await this.store.destroy(cycle);
  }

  async duplicateCycle(cycle) {
    const {model} = await this.store.post(
      cycle.link('duplicate'),
      types.PERFORMANCE_REVIEWS.CYCLE
    );

    if (model) {
      this.history.push(`/reviews/${model.id}/edit`);
    }
  }

  async reopenCycle() {
    if (!this.selectedCycle) return;
    
    const {model} = await this.store.patch(
      this.selectedCycle.link('reopen'),
      types.PERFORMANCE_REVIEWS.CYCLE,
      this.selectedCycle
    );

    if (model) {
      this.interactiveAgent.refresh();
      successAlert(t('performance.reopen_modal.Review cycle reopened.'));
      this.closeReopenCycleModal();
    }
  }

  cyclePath(cycle) {
    switch (cycle.state) {
      case 'created':
        return `/reviews/${cycle.id}/edit`;
      case 'configured':
        return `/reviews/${cycle.id}/manage`;
      case 'launched':
      case 'ended':
      default:
        return `/reviews/${cycle.id}`;
    }
  }

  customLinksFor(cycle) {
    const links = [];

    if (cycle.hasLink('reopen')) {
      links.push({
        order: 0,
        text: 'performance.Reopen',
        action: model => this.openReopenCycleModal(model)
      });
    }

    if (cycle.hasLink('duplicate')) {
      links.push({
        order: 1,
        text: 'performance_reviews.directory.Duplicate',
        action: model => this.duplicateCycle(model)
      });
    }

    return links;
  }
}

export default CycleDirectoryState;
